import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import {Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {BlackCrossOutlined} from '@jobseeker/lotus/icons';
import {PropTypes} from '../type';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
  '.MuiDialog-paper': {
    borderRadius: theme.spacing(2),
  },
  [theme.breakpoints.down('md')]: {
    '.MuiDialog-paper': {
      borderRadius: theme.spacing(0),
    },
  },
  // '& .MuiDialogContent-root': {
  //   padding: theme.spacing(2),
  // },
  // '& .MuiDialogActions-root': {
  //   padding: theme.spacing(1),
  // },
}));

const Component = ({title, subtitle, invertedTitle, ...props}: PropTypes) => {
  const handleClose = (event: any) => {
    if (props.onClose) props.onClose(event, 'escapeKeyDown');
  };
  const isLarge = useIsLargeDevice();
  return (
    <div>
      <BootstrapDialog
        {...props}
        fullScreen={props.fullScreen ?? (isLarge ? false : undefined)}
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            width: '93%',
            maxWidth: props.paperMaxWidth ? props.paperMaxWidth : '400px',
            borderRadius: '20px',
            margin: 0,
          },
        }}
      >
        <Box
          sx={{
            py: 0,
            overflow: 'hidden',
            position: 'relative',
            background: '#FFFFFF',
            pr: 6,
            borderBottom: '1px solid #EEEEEE',
          }}
        >
          <DialogTitle sx={{paddingLeft: '16px'}}>
            {invertedTitle ? (
              <>
                {subtitle && (
                  <Typography color="primary.contrastText" variant="body2">
                    {subtitle}
                  </Typography>
                )}
                <Typography
                  color="primary.contrastText"
                  fontSize={{xxs: 18, md: 20}}
                  fontWeight={600}
                >
                  {title}
                </Typography>
              </>
            ) : (
              <>
                <Typography
                  color="#333333"
                  fontSize={{xxs: 14, md: 16}}
                  fontWeight={500}
                >
                  {title}
                </Typography>
                {subtitle && (
                  <Typography
                    color="#7E7E7E"
                    fontSize={{xxs: 12}}
                    fontWeight={400}
                  >
                    {subtitle}
                  </Typography>
                )}
              </>
            )}
          </DialogTitle>
          <Box
            sx={{
              position: 'absolute',
              right: 8,
              zIndex: 1,
              top: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <IconButton aria-label="close" onClick={handleClose}>
              <Image
                width={18}
                height={18}
                src={BlackCrossOutlined}
                alt={'black cross'}
              />
            </IconButton>
          </Box>
        </Box>
        <DialogContent sx={{padding: 0}}>{props.children}</DialogContent>
        {props.footer}
      </BootstrapDialog>
    </div>
  );
};

export default Component;
